<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <div class="content">
      <div class="left">
        <!-- <div class="top">
          <el-input class="ipt" placeholder="请输入车牌号" v-model="form.license"></el-input>
          <el-button class="btn" icon="el-icon-search" @click="search"></el-button>
        </div> -->
        <el-menu :default-active="menuIndex" class="con-menu" mode="horizontal" @select="handleSelect">
          <el-menu-item v-for="(c, i) in menu" :key="i" :index="c" :class="[menuIndex === c ? 'active' : '']">{{ c
            }}</el-menu-item>
        </el-menu>
        <el-scrollbar class="list">
          <div class="item" v-for="(c, i) in list" :key="'item' + i" :class="[itemIndex === c.license ? 'active' : '']"
            @click="onSelect(c)">
            <div class="wrap">
              <div class="l">{{ c.license }}</div>
              <div class="r" :class="[c.type === '离线' ? 'red' : '']">{{ c.type }}</div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { EventBus } from '../EventBus'

export default {
  name: "VehicleList",
  data() {
    return {
      breadcrumb: [
        { name: "车辆定位" },
        { name: "车辆列表" },
      ],
      list: [],
      searchStr: '',
      menuIndex: '全部',
      menu: ['全部', '在线', '离线'],
      form: {},
      itemIndex: '',
    };
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    search() {
      // console.log({ ...this.form })
      this.getData()
    },
    handleSelect(key) {
      // console.log(key);
      if (key === '全部') {
        this.form = {}
      } else[
        this.form['type'] = key
      ]
      this.getData()
    },
    getData() {
      this.list = []
      this.post(`index/getcarstate`, { ...this.form }, ({ list }) => {
        if (list && list[0]) {
          this.list = [...list]
        } else {
          // this.$message({
          //   type: 'error',
          //   message: '暂无数据！'
          // });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSelect({ license }) {
      this.itemIndex = license
      // console.log(license)
      EventBus.$emit('selectLisence', license);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.main {
  margin: 0;
}

.content {
  display: flex;
  height: 100vh;
  height: calc(100vh - 147px);

  .left {
    height: 100%;
    width: 250px;
    background: #fff;
    margin-right: 10px;
    // overflow-x: hidden;
    // overflow-y: auto;

    .top {
      margin: 10px 10px;
      position: relative;

      .ipt {
        background: #F9FAFC;
      }

      .btn {
        position: absolute;
        right: 2px;
        top: 2px;
        border: 0 none;
        height: 36px;
      }
    }

    .con-menu {
      /deep/.el-menu-item {
        width: 33.3%;
        text-align: center;
        height: 40px;
        line-height: 40px;
        // background-color: #F9FAFC;
      }
    }

    .list {
      // height: calc(100vh - 247px);
      height: calc(100vh - 187px);
      // overflow-x: hidden;
      // overflow-y: auto;
    }

    .item {
      padding: 10px;
      cursor: pointer;

      .wrap {
        display: flex;
        justify-content: space-between;
      }

      &.active {
        background: #FFF5EC;
      }

      .r {
        color: #67C23A;

        &.red {
          color: #F56C6C;
        }
      }
    }
  }

  .right {
    flex: 1;
    background: #fff;
    padding: 10px;
  }
}
</style>
